import { CUSTOMER_CONFIG } from "../../../DriverPopUp/common/constants";
import {
  DEFAULT_DISPATCH_GRID_FILTER_LIST,
  PICKUPS_GRID_FILTERS as DEFAULT_PICKUPS_GRID_FILTERS,
} from "./DEFAULT_constants";
import {
  SMT_DISPATCH_GRID_FILTER_LIST,
  PICKUPS_GRID_FILTERS as PICKUPS_GRID_FILTERS_SMT,
} from "./SMT_constants";
import { withAppConfig } from "../../../../../../../appConfigContext";
const getPickupsGridFilters = (pickupTypeFilterConfig) => {
  if (pickupTypeFilterConfig === CUSTOMER_CONFIG.SMT) {
    return {
      options: SMT_DISPATCH_GRID_FILTER_LIST,
      defaultFilter: SMT_DISPATCH_GRID_FILTER_LIST.find(
        (filter) => filter.value === PICKUPS_GRID_FILTERS_SMT.unassigned
      ),
    };
  }
  return {
    options: DEFAULT_DISPATCH_GRID_FILTER_LIST,
    defaultFilter: DEFAULT_DISPATCH_GRID_FILTER_LIST.find(
      (filter) => filter.value === DEFAULT_PICKUPS_GRID_FILTERS.unassigned
    ),
  };
};

const WithPickupsGridFilterHOC = (Component) => {
  return withAppConfig((props) => {
    const { options, defaultFilter } = getPickupsGridFilters(
      props.configJSON?.pickupTypeFilter
    );
    return (
      <Component options={options} defaultFilter={defaultFilter} {...props} />
    );
  });
};
export { WithPickupsGridFilterHOC };
